import React, { useEffect, useState } from 'react';
import { XIcon, UserIcon, SettingsIcon, LogOutIcon, CreditCardIcon, ExternalLinkIcon } from 'lucide-react';
interface UserMenuProps {
  onClose: () => void;
}
export const UserMenu = ({
  onClose
}: UserMenuProps) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  if (isMobile) {
    return <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center" data-id="element-723">
        <div className="bg-[#282828] rounded-lg w-full max-w-sm mx-4 overflow-hidden" data-id="element-724">
          <div className="p-4 border-b border-white/10 flex items-center justify-between" data-id="element-725">
            <h2 className="text-xl font-bold" data-id="element-726">Account</h2>
            <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-727">
              <XIcon className="w-6 h-6" data-id="element-728" />
            </button>
          </div>
          <div className="p-4 border-b border-white/10" data-id="element-729">
            <div className="flex items-center" data-id="element-730">
              <div className="bg-[#333] rounded-full p-2 mr-3" data-id="element-731">
                <UserIcon className="w-6 h-6 text-gray-300" data-id="element-732" />
              </div>
              <div data-id="element-733">
                <div className="font-medium" data-id="element-734">User Name</div>
                <div className="text-sm text-gray-400" data-id="element-735">user@example.com</div>
              </div>
            </div>
          </div>
          <div className="py-2" data-id="element-736">
            <MenuItem icon={<UserIcon className="w-5 h-5" data-id="element-738" />} label="Profile" data-id="element-737" />
            <MenuItem icon={<CreditCardIcon className="w-5 h-5" data-id="element-740" />} label="Account" data-id="element-739" />
            <MenuItem icon={<SettingsIcon className="w-5 h-5" data-id="element-742" />} label="Settings" data-id="element-741" />
            <MenuItem icon={<ExternalLinkIcon className="w-5 h-5" data-id="element-744" />} label="Support" external data-id="element-743" />
            <MenuItem icon={<LogOutIcon className="w-5 h-5" data-id="element-746" />} label="Log out" onClick={onClose} data-id="element-745" />
          </div>
        </div>
      </div>;
  }
  return <div className="fixed top-16 right-8 z-50" data-id="element-747">
      <div className="bg-[#282828] rounded-lg shadow-xl w-64 overflow-hidden" data-id="element-748">
        <div className="p-4 border-b border-white/10" data-id="element-749">
          <div className="flex items-center" data-id="element-750">
            <div className="bg-[#333] rounded-full p-2 mr-3" data-id="element-751">
              <UserIcon className="w-6 h-6 text-gray-300" data-id="element-752" />
            </div>
            <div data-id="element-753">
              <div className="font-medium" data-id="element-754">User Name</div>
              <div className="text-sm text-gray-400" data-id="element-755">user@example.com</div>
            </div>
          </div>
        </div>
        <div className="py-1" data-id="element-756">
          <MenuItem icon={<UserIcon className="w-5 h-5" data-id="element-758" />} label="Profile" data-id="element-757" />
          <MenuItem icon={<CreditCardIcon className="w-5 h-5" data-id="element-760" />} label="Account" data-id="element-759" />
          <MenuItem icon={<SettingsIcon className="w-5 h-5" data-id="element-762" />} label="Settings" data-id="element-761" />
          <MenuItem icon={<ExternalLinkIcon className="w-5 h-5" data-id="element-764" />} label="Support" external data-id="element-763" />
          <MenuItem icon={<LogOutIcon className="w-5 h-5" data-id="element-766" />} label="Log out" onClick={onClose} data-id="element-765" />
        </div>
      </div>
    </div>;
};
interface MenuItemProps {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  external?: boolean;
}
const MenuItem = ({
  icon,
  label,
  onClick,
  external
}: MenuItemProps) => <button className="flex items-center w-full px-4 py-3 hover:bg-white/10 transition-colors text-left" onClick={onClick} data-id="element-767">
    <span className="mr-3 text-gray-300" data-id="element-768">{icon}</span>
    <span data-id="element-769">{label}</span>
    {external && <ExternalLinkIcon className="w-4 h-4 ml-auto text-gray-400" data-id="element-770" />}
  </button>;